export default {"src":"/_next/static/media/general_specs_icon.b1d74c06.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};